import { render } from "./list.vue?vue&type=template&id=71b0b6b4&scoped=true"
import script from "./list.vue?vue&type=script&lang=js"
export * from "./list.vue?vue&type=script&lang=js"

import "./list.vue?vue&type=style&index=0&id=71b0b6b4&scoped=true&lang=css"

import exportComponent from "D:\\project\\xiongmao-admin\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-71b0b6b4"]])

export default __exports__